import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { Oracle, Queue } from '@switchboard-xyz/on-demand';
import { State } from '@switchboard-xyz/on-demand';

export default class GuardianCreate extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Create a guardian account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
  };

  static args = {};

  async run() {
    // const { args, flags } = await this.parse(
    //   this.constructor as typeof GuardianCreate
    // );

    const program = await this.program;

    const state = new State(program);
    const stateData = await state.loadData();
    const guardianQueue = stateData.guardianQueue;

    // Create the oracle init instructions.
    const [oracle, ixs, kp] = await Oracle.create(program, {
      queue: guardianQueue,
    });
    const queueAccount = new Queue(oracle.program, guardianQueue);
    const queueLut = await queueAccount.loadLookupTable();

    // Sign and send the transaction
    await this.signAndSend(ixs, [queueLut], [kp]);

    // Print the guardian oracle and queue keys to the console
    console.log();
    console.log(`GUARDIAN_ORACLE=${oracle.pubkey.toBase58()}`);
    console.log(`GUARDIAN_QUEUE=${guardianQueue.toBase58()}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, '# GUARDIAN - failed to create guardian account');
  }
}
